import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  Image,
  TypographyStylesProvider,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconCircleMinus,
  IconExchange,
  IconPlugConnected,
} from "@tabler/icons-react";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const OPENING_CHANNELS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      When you first start Rizful, you'll likely see that the Open Channel
      button is disabled:
    </p>

    <DocsButton
      ariaLabel="open channel to peer"
      text="Open Channel"
      leftSection={<IconExchange />}
      disabled={true}
    />

    <p>
      {" "}
      In order to enable it, you'll need to{" "}
      <a href="/docs/deposit-withdraw-btc#deposit-btc" target="_blank">
        deposit BTC{" "}
      </a>{" "}
      to your node. Make sure to follow the suggestions on the amount to deposit
      -- you can't open a channel with less than around 200,000 satoshis!
    </p>

    <p> You should then see that the button is enabled.</p>
    <DocsButton
      ariaLabel="open channel to peer"
      text="Open Channel"
      leftSection={<IconExchange />}
      disabled={false}
    />
    <p> If it's enabled, you can click it to open a channel.</p>
    <p>
      {" "}
      If you have a too-small BTC Balance, you might see a warning like this.
    </p>

    <SimpleImage
      h={200}
      src="docs_images/open-channel-to-peer-not-enough-satoshis-warning.png"
    />

    <p>
      {" "}
      Rizful Node dynamically looks at the on-chain fees and tells you how much
      BTC you need on hand to open a channel. This is to protect you: Opening
      too-small channels, or opening a channel and not leaving enough left-over
      funds on the node, is bad practice, so we prevent you from making this
      mistake.
    </p>

    <p>
      If you've got enough on-chain BTC on your node to open a channel, you'll
      then see this screen:
    </p>

    <SimpleImage h={400} src="docs_images/open-a-channel-full-options.png" />
    <p> Here you have some choices to make:</p>

    <p>
      You can <strong>select a peer</strong>. Note, that if your preferred peer
      is not shown, you can go back to the main screen and use this button to
      add the peer:
    </p>
    <DocsButton
      ariaLabel="add peer"
      text="Add Peer"
      leftSection={<IconPlugConnected />}
      disabled={false}
    />
    <p>
      {" "}
      The <strong>Satoshis</strong> size of the channel is the amount of BTC
      you're putting into the channel. The larger the channel, the more you can
      send through it. The smaller the channel, the less you can send through
      it. You'll see that the default amount is 150,000 satoshis, but we
      recommend making bigger channels than that: At least 500,000 or 1,000,000
      satoshis is a good choice.
    </p>

    <p>
      You will also see Rizful's <strong>fee estimate</strong> for the amount of
      fees you'll pay. Note that fees do NOT vary with the size of channel. And
      that's one reason that{" "}
      <strong>big channels are more economically efficient</strong> when
      compared to smaller channels. If you're going to pay an on-chain fee,
      you're better off getting a bigger channel out of it, instead of a smaller
      channel.
    </p>

    <p>
      Next you can determine if you want a <strong>Private Channel</strong> or
      not. A private channel works well for sending payments and receiving
      payments to your node. Other nodes in the network can not however receive
      payments through YOUR private channel. Put another way: You can't "route"
      for other nodes through your private channels. If there is a node
      "upstream" from you, that you'd like to be able to "route" payments to,
      you will want to uncheck the private channel checkbox, and make a public
      channel, instead.
    </p>

    <p>
      Once you finalize your options and click the "Open Channel" button, you'll
      see a notification that a BTC transaction is pending.
    </p>
    <SimpleImage h={150} src="docs_images/btc-transaction-pending.png" />

    <p>
      Now, let's repeat this because it can be confusing: You are opening a
      lightning channel, so you can send lightning payments. But to open this
      channel, you need to make one on-chain transaction. And that transaction
      might be slow, and it will cost some fees.
    </p>
    <p>
      At this point, you can look at the balances near the top of the interface,
      and you should see that your node is now showing some Pending BTC:
    </p>
    <SimpleImage
      h={100}
      src="docs_images/pending-btc-after-channel-open2.png"
    />
    <p>
      Rizful Node$1 ... And you should shortly see that a channel appears on the
      Rizful interface, in the OPENING status...
    </p>
    <SimpleImage h={200} src="docs_images/channel-opening2.png" />
    <p> Good work! You've opened a channel.</p>
  </TypographyStylesProvider>
);
